/**
 * Pega como alvo o elemento container toolbar e pára a propagação para outros
 * elementos que não são filhos deste container.
 *
 * @author Daniel Laurindo Date: 19/02/2012 Time: 11:00
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.Util = Greenmile.Toolbar.Map.Util || {};

/*
 * @params {string} lat : Latitude que será usada para colocar o marker no mapa
 * @params {string} longit : Longitude que será usada para colocar o marker no
 * mapa @params {integer} routeId : É utilizado nos casos que o mapa são do
 * route details, se forem em outros casos deverá passar null, esse caso, será
 * considerado o mapa que for passado como parâmetro.
 * 
 * @params {} kind : tipo @params {object} map : Instancia do mapa que foi
 * criado para a tela em questão
 * 
 * Exemplo com routeId: Greenmile.RouteDetail.Util.addMarkerToMap =
 * function(lat, longit, address, routeId, kind)
 * 
 * Exemplo sem routeId: Greenmile.RouteDetail.Util.addMarkerToMap =
 * function(lat, longit, address, null, kind, map)
 * 
 */
Greenmile.Toolbar.Map.Util.addMarkerToMap = function (lat, longit, address, routeId, kind, map) {

    this.marker = null;
    this.icon = null;

    if (routeId !== null) {
        this.map = Monet.Session.RouteDetail.screensList[routeId].map;
    } else if (map) {
        this.map = map;
    } else {
        return;
    }

    if (this.map && lat && longit) {

        this.icon = L.icon({
            iconUrl: require("static/images/map/markers/generic_marker_blue.png"),
            iconSize: [15, 26],
            iconAnchor: [7.5, 26],
            popupAnchor: [37, -15]
        });

        this.marker = L.marker([lat, longit], {
            icon: this.icon
        });
        
        const popupContent = document.createElement('div');
        popupContent.classList.add("address");
        const popupContentStrong = document.createElement('strong');
        const popupContentResource = document.createTextNode(Monet.I18n.getResourcesByKey('routeDetails.addressPopup.label') + ': ');
        popupContentStrong.appendChild(popupContentResource);
        popupContent.appendChild(popupContentStrong);
        const addressContent = ((typeof address == 'string' || address instanceof String) ? document.createTextNode(address) : address);
        popupContent.appendChild(addressContent);

        this.marker.kind = kind;
        this.marker.addTo(this.map).bindPopup(popupContent).openPopup();
        this.map.setZoom(14);
        this.map.panTo([lat, longit]);

        return true;
    }

    return false;

};

Greenmile.Toolbar.Map.Util.mouseWheelHandler = function (id) {

    if (id !== null && typeof (id.addEventListener) !== "undefined") {

        if (id.addEventListener) {

            // IE9, Chrome, Safari, Opera
            id.addEventListener("mousewheel", MouseWheelHandler, false);

            // Firefox
            id.addEventListener("DOMMouseScroll", MouseWheelHandler, false);

        } else {

            // IE 6/7/8
            id.attachEvent("onmousewheel", MouseWheelHandler);

        }

    } else {

        return false;

    }

    function MouseWheelHandler (ev) {

        // cross-browser wheel delta
        var event = window.event || ev; // old IE support

        if (event.stopPropogation) {

            event.stopPropogation();

        } else { // Older IE.

            event.cancelBubble = true;

        }

        return false;
    }

};

Greenmile.Toolbar.Map.Util.handleToolbarSearchContainer = function (selector) {
    this.mountSection = () => {
        const loadingElement = document.createElement('div');
        loadingElement.setAttribute('id', 'streetSearchResult-loading');
    
        const legendTraslated = Monet.I18n.getResourcesByKey('Greenmile.grid.showTotals.nothingData');
    
        const textElement = document.createElement('p');
        textElement.innerHTML = legendTraslated;
    
        const noDataElement = document.createElement('div');
        noDataElement.appendChild(textElement);
        noDataElement.style.display = 'none';
        noDataElement.setAttribute('id', 'streetSearchResult-without-results');
    
        const selectAddress = document.createElement("select");
        selectAddress.setAttribute("multiple", true);
        selectAddress.setAttribute('id', 'multiSearchOnMap');
        selectAddress.style.display = 'none';
    
        const searchListBox = $(selector + " .streetSearchResult");
        searchListBox.show();
        searchListBox.html('') && searchListBox.append(loadingElement, noDataElement, selectAddress);
    };

    this.showContent = () => {
        const noDataContainerSelector = $(selector + " #streetSearchResult-without-results");
        const contentDataSelector = $(selector + " #multiSearchOnMap");
        const loadingSelector = $(selector + " #streetSearchResult-loading");

        loadingSelector.hide();
        noDataContainerSelector.hide();
        contentDataSelector.show();
    };

    this.showNotDataText = () => {
        const noDataContainerSelector = $(selector + " #streetSearchResult-without-results");
        const contentDataSelector = $(selector + " #multiSearchOnMap");
        const loadingSelector = $(selector + " #streetSearchResult-loading");
        
        contentDataSelector.hide();
        loadingSelector.hide();
        noDataContainerSelector.show();
    };

    return this;
}